import React from 'react';
import { RouteIcon, BookOpenIcon, EyeIcon, TrendingUpIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = [RouteIcon, BookOpenIcon, EyeIcon, TrendingUpIcon];
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-pitch" data-id="element-16" data-mp="3npb4tilqeuhn">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3nngjw4agn2dk">
        <h2 id="beneficios" className="font-display text-[1.8rem] font-normal uppercase leading-[1.05] text-white sm:text-5xl" data-id="element-18" data-mp="38qz7raug5jpy">
          ¿Qué puede cambiar cuando{' '}
          <span className="text-gold" data-id="element-19" data-mp="2zsdt3qs3ioug">empiezas?</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/85" data-id="element-20" data-mp="34q5lsn0keezp">
          Una planificación organizada puede transformar la manera en que
          preparas y diriges tus entrenamientos.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-21" data-mp="12zlp73d7f4nw">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[i];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-gold bg-white p-2.5 text-left" data-id="element-22" data-mp="2bd30zuvz56rr" data-mpi={i}>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-field text-white" aria-hidden="true" data-id="element-23" data-mp="2g5dzquezamiq">
                  <Icon size={16} data-id="element-24" data-mp="1of83f3e193ol" />
                </span>
                <div data-id="element-25" data-mp="1ogsxyt0ckmmg">
                  <h3 className="font-sub text-sm font-extrabold leading-tight text-pitch" data-id="element-26" data-mp="22ehks6dz63u5">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-pitch/80 sm:text-sm" data-id="element-27" data-mp="1xemuo520xia5">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}